import { render, staticRenderFns } from "./LanguageFloatBall.vue?vue&type=template&id=47484062&scoped=true"
import script from "./LanguageFloatBall.vue?vue&type=script&lang=js"
export * from "./LanguageFloatBall.vue?vue&type=script&lang=js"
import style0 from "./LanguageFloatBall.vue?vue&type=style&index=0&id=47484062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47484062",
  null
  
)

export default component.exports